<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZgWIU8/media/FC-9781035882656.jpg?1736120036500" alt="This image is the cover for the book The Da Calvi Legacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Da Calvi Legacy
      </h1>
      <p class="bookDescription body article font2">
        <p>Cristi Jenkins is leading a quiet life as a primary school teacher in a small village on the coast of West Wales. Stuck in this familiar backwater, she feels her life is going nowhere. Then, out of the blue, she receives a mysterious letter bearing an Italian postmark... Cristi knows her only link to Italy is a tenuous one – the mother she never really knew, and definitely can’t remember. Yet her story is about to become inextricably linked to that of the Da Calvi family – four brothers torn apart by war, and an unbreakable bond between two young boys forged years before. In modern day Italy, Seb Luce is the attractive Italian lawyer entrusted with Ennio Da Calvi’s affairs. The file appeals to his curiosity and determination to find answers to the questions left by an intriguing legacy… What does all of this mean for Cristi, what decisions will she face, and is this a chance for her to find out who she really is?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judith Barclay
      </h2>
      
      <p class="authorDescription body article">Judith Barclay was born and bred in Goodwick, Pembrokeshire. She has a degree in education from the University of Nottingham and started writing seriously after retiring from a career in teaching. She enjoys walking, reading psychological thrillers and has travelled extensively all over Europe, and in Africa and Asia. She has held a lifelong passion for Italy and all things Italian and was inspired to write this book by her research into the history of the mass immigration and integration of Italians into Wales from the late nineteenth century. Judith has twin daughters, Emily and Joanna, and lives in Derbyshire with her husband, Chris.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?307c2e0b